/**
 * Created by rickborst on 24/04/2017.
 */

const TYPES = {
    API_ERROR: 'api-error'
};

export default TYPES;


// WEBPACK FOOTER //
// ./src/js/errors/types.js